import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import {Router} from '@angular/router';

import {LIST_TYPE} from '../../defines/client.const';
import {ExampleSJ, LinkedExample} from '../../models/word.model';
import {VoiceService} from '../../services/voice/voice.service';

@Component({
  selector: 'app-linked-example-popup',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './linked-example-popup.component.html',
  styleUrls: ['./linked-example-popup.component.scss'],
})
export class LinkedExamplePopupComponent implements OnChanges {
  @HostBinding('class') hostClass = 'link-popup popup-connect type-shadow';
  @Input() example: LinkedExample;
  @Output() closePopup = new EventEmitter<void>();
  exampleSJ: ExampleSJ | null = null;

  constructor(
    private voice: VoiceService,
    private cdr: ChangeDetectorRef,
    private router: Router,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.example) return;

    if (!this.example?.example_t) {
      this.exampleSJ = null;
      return;
    }

    this.exampleSJ = {
      seungjo: this.example.example_s,
      example: this.example.example_t,
      highlight: this.example.example_highlight,
      voiceExIdx: null,
    };
  }

  onClose(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.closePopup.emit();
  }

  onVoid(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onClickDetail(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    if (!this.example?.id) {
      console.error('LinkedExamplePopupComponent::onClickDetail() invalid example', this.example);
      return;
    }

    const exampleId = this.example.id;
    this.voice.Stop();
    this.closePopup.emit();
    this.router.navigate(['/example'], {
      queryParams: {
        l: LIST_TYPE.SERVER,
        start: exampleId,
        id: exampleId,
      },
    }).then();
  }

  playSound(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();

    if (!this.example?.id || !this.example.example_voice) {
      console.error('LinkedExamplePopupComponent::playSound() invalid example voice', this.example);
      return;
    }

    if (this.on) {
      this.voice.Stop();
      this.cdr.markForCheck();
    }
    else {
      this.voice.PlayExample(this.example.id, this.example.example_voice).subscribe({
        error: err => {
          console.error('LinkedExamplePopupComponent::playSound error', err);
          this.cdr.markForCheck();
        },
        complete: () => this.cdr.markForCheck(),
      });
    }
  }

  get on(): boolean {
    return this.voice.on && this.voice.exampleId === this.example?.id;
  }

  get hasVoice(): boolean {
    return !!this.example?.example_voice;
  }
}
